import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenticationService} from '@modules/authentication';
import {defaultRoute} from '../settings';

@Injectable({
    providedIn: 'root'
})
export class IsAtLeastTrainerGuard  {
    constructor(private authService: AuthenticationService, private router: Router) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const canActivate = this.authService.isAtLeastTrainer();
        if (canActivate === false) {
            this.router.navigate([defaultRoute]);
        }
        return canActivate;
    }

}
